/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import { OverlayTypes } from '../overlay/OverlayTypes';

export interface IOverlayOptions {
    text: string;
    displayValue?: {
        type: 'image' | 'string';
        value: Array<string>;
    };
    hasSelectMark?: boolean;
    horizontalSelectionoptions?: Array<string>;
    hrBottom?: boolean;
    hrTop?: boolean;
    isSelected?: boolean;
    value?: any;
}

export const DescriptionType = {
    DEFAULT: 'DEFAULT',
    PROGRAM_DESCRIPTION: 'PROGRAM_DESCRIPTION',
};

export interface IDescriptionEntry {
    text: string;
    hrBottom?: boolean;
    hrTop?: boolean;
    descriptionType?: typeof DescriptionType[keyof typeof DescriptionType];
}

export interface IOverlayDialog {
    hasDimmer: boolean;
    hasSeperator: boolean;
    options: Array<IOverlayOptions>;
    title: string;
    description?: string | Array<IDescriptionEntry>;
    enableCaret?: boolean;
    errorPriority?: number;
    iconURL?: string;
    isPersistent?: boolean;
    messageCode?: string;
    mouseTrapValue?: string;
    onAutoHide?: Function;
    overlayType?: OverlayTypes;
    subtitle?: string | { text: string; icon: string };
    verticalPositionCaretAvailable?: Array<number>;
}
